export var CustomPDFReportNumRequiredSecurities;
(function (CustomPDFReportNumRequiredSecurities) {
    CustomPDFReportNumRequiredSecurities[CustomPDFReportNumRequiredSecurities["ONE"] = 1] = "ONE";
    CustomPDFReportNumRequiredSecurities[CustomPDFReportNumRequiredSecurities["TWO"] = 2] = "TWO";
    CustomPDFReportNumRequiredSecurities[CustomPDFReportNumRequiredSecurities["THREE_PLUS"] = 3] = "THREE_PLUS";
})(CustomPDFReportNumRequiredSecurities || (CustomPDFReportNumRequiredSecurities = {}));
